import React from "react";
import { Typography } from "antd";

const { Text } = Typography;

export const DeletedUser = () => (
  <Text style={{ color: "red", margin: '0 5px 0 0' }}>Deleted User</Text>
);
